module.exports = __webpack_public_path__ + "static/media/icon-facebook.700dba70.svg";